import { createApp } from 'vue'
import { App } from '@/ui/page/app'
import { router } from '@/config/router/router'
import { clickOutside } from './directives/clickOutside'
import dayjs from 'dayjs'
import { createPinia } from 'pinia'
import isToday from 'dayjs/plugin/isToday'
import './assets/styles/main.css'

const pinia = createPinia()

const app = createApp(App)
await loadPlugins(app)

app.config.globalProperties.$dayjs = dayjs
dayjs.extend(isToday)

app.use(pinia).use(router).mount('#app')
app.directive('click-outside', clickOutside)


// Предотвращение двойного тапа. Было недостаточно одного лишь мета тега.
let lastTouchEnd = 0
document.addEventListener('touchend', (e) => {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    e.preventDefault()
  }
  lastTouchEnd = now
}, false)


async function loadPlugins(app: any) {
  const plugins: any = import.meta.glob('./plugins/*.ts')
  for (const path in plugins) {
    console.log('Loading plugin: ' + path)
    const plugin = await plugins[path]()
    app.use(plugin.default, { router })
  }
}
